import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { ProjectActivityRepository } from "@project/data/repositories/technical-proposal/activity.repository";
import { inject, injectable } from "inversify";
import { Activity } from "../../models/technical-proposals.model";

@injectable()
export class EditKanbanActivityUseCase {
    constructor(
        @inject(ProjectActivityRepository)
        private readonly projectActivityRepository: ProjectActivityRepository,
    ) {}

    async edit(activity: Activity): Promise<boolean> {
        const aditActivityResult =
            await this.projectActivityRepository.editKanban(activity);

        if (aditActivityResult.isLeft()) {
            ToastManagerStore.error(
                aditActivityResult.getLeftOrThrow().message,
            );
        }

        return aditActivityResult.isRight();
    }
}
